import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { companyLogo } from "../../assets/images";
import { IconBrandFacebook, IconBrandTwitter } from "@tabler/icons-react";
import { registerUser } from "../../services/dataService";
import CustomAlert from "../../components/common/CustomAlert";

export default function Register() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [success, setSuccess] = useState(null); // For success message

  const [formData, setFormData] = useState({
    Name: "",
    UserName: "",
    Password: "",
    ProfitCenterId: "",
    DepartmentId: "",
    Roles: "",
    Employer: 1,
    UserRight: "",
    PageRights: "",
    Roles: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    setError("");
    setSuccess("");

    try {
      const response = await registerUser(formData);
      if (response.data.message === "Login successful") {
        setSuccess("User login successfully!"); 
        setError(null);

        await delay(1000);

        // Now navigate after the delay
        navigate("/login"); // Navigate to the home page
        window.location.reload();
      }
    } catch (error) {
      console.error("Error login user:", error);
      setError("Error login user. Please try again.");
      setSuccess(null);
    }
  };

  return (
    <div className='flex min-h-svh items-center before:content-[""] before:fixed before:left-0 before:top-0 before:w-full sm:before:max-w-[400px] before:max-w-[100%] before:h-full before:z-[-1] before:bg-bg-auth after:content-[""] after:fixed after:right-0 after:top-0 after:w-full after:h-full after:z-[-2] after:bg-[url("../images/auth_bg.jpg")] after:bg-no-repeat after:bg-center'>
      <div className="w-full lg:max-w-[380px] sm:max-w-[80%] max-w-[90%] lg:ml-[130px] m-auto py-30">
        <div className="sm:mb-30 mb-20">
          <img
            src={companyLogo}
            width="130"
            height="38"
            alt="company logo"
            className="invert"
          />
        </div>
        <div className="sm:p-30 p-20 bg-bg-dark shadow-light rounded-lg">
          <div className="mb-30 text-[18px]/[24px]">Create an account</div>
          <form onSubmit={handleSubmit} className="flex flex-col gap-20">
            <div className="form-group">
              <input
                type="text"
                id="name"
                name="Name"
                placeholder="Your Name"
                value={formData.Name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="UserName"
                id="UserName"
                name="UserName"
                placeholder="Your Email"
                value={formData.UserName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="Password"
                id="Password"
                name="Password"
                placeholder="Password"
                value={formData.Password}
                onChange={handleChange}
                required
              />
            </div>
            <button type="submit" className="btn btn-primary uppercase">
              Register
            </button>
          </form>
          {error && <div className="text-red-500 mt-2">{error}</div>}
          {success && <div className="text-green-500 mt-2">{success}</div>}
          <div className="flex flex-col items-center gap-10 mt-20">
            <div className="flex items-center gap-5 text-text-secondary">
              Already have an account?
              <Link
                to="/"
                className="text-blue transition-all duration-300 hover:text-blue-100"
              >
                Login
              </Link>
            </div>
          </div>
          <div className='my-30 text-center relative before:content-[""] before:absolute before:w-full before:h-[1px] before:bg-border before:top-[50%] before:translate-y-[-50%] before:left-0'>
            <span className="inline-block relative z-[1] px-10 bg-bg-dark">
              OR
            </span>
          </div>
          <div className="flex flex-col gap-10">
            <button className="flex items-center gap-10 justify-center py-10 px-20 bg-bg-dark w-full rounded border border-border transition-all duration-300 hover:bg-bg-light-100">
              <IconBrandFacebook className="w-[18px] h-[18px] stroke-[0] bg-blue-100 fill-white rounded-full p-[2px]" />
              Sign up with Facebook
            </button>
            <button className="flex items-center gap-10 justify-center py-10 px-20 bg-bg-dark w-full rounded border border-border transition-all duration-300 hover:bg-bg-light-100">
              <IconBrandTwitter className="w-[18px] h-[18px] stroke-[0] bg-sky fill-white rounded-full p-[2px]" />
              Sign up with Twitter
            </button>
          </div>
          <CustomAlert
            message={error || success} // Show either error or success message
            type={error ? "error" : "success"} // Set alert type based on the message
            onClose={() => {
              setError(null); // Clear error message on close
              setSuccess(null); // Clear success message on close
            }}
          />
        </div>
      </div>
    </div>
  );
}
